import React, { FunctionComponent } from "react";
import { Box, Stack } from "@mui/material";
import { Drawer, CloseButton, H5Bold } from "components";

import { InvitedUsersList } from "./components";
import { ManageUsersDrawerProps } from "./types";

export const ManageUsersDrawer: FunctionComponent<ManageUsersDrawerProps> = ({ isOpen, onClose }) => (
  <Drawer
    anchor="right"
    open={isOpen}
    onClose={onClose}
    variant="temporary"
    customPaperProps={{ width: "80vw" }}
    expandedWidth="80vw"
    zIndex={1300}
  >
    <Stack
      direction="column"
      justifyContent="flex-start"
      alignItems="stretch"
      spacing={3}
      height="100%"
      padding="0px"
    >
      <Box
        component="header"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: "24px",
          pt: "34px"
        }}
      >
        <H5Bold>Manage users</H5Bold>
        <CloseButton onClick={onClose} />
      </Box>
      <InvitedUsersList />
    </Stack>
  </Drawer>
);
